import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-cream py-16 sm:py-20" aria-labelledby="guarantee-title" data-id="element-101" data-mp="4vry1r9ge1np">
      <div className="mx-auto max-w-2xl px-4 text-center" data-id="element-102" data-mp="9tl7ct61zbs7">
        <motion.div initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="rounded-2xl border border-earth-200 bg-white p-8 shadow-lg shadow-earth-900/10 sm:p-12" data-id="element-103" data-mp="et6735t1ro5z">
          <span className="inline-flex rounded-full border-4 border-gold-500 bg-forest-800 p-4 text-gold-400" data-id="element-104" data-mp="slvsp94nyr2k">
            <ShieldCheckIcon className="h-10 w-10" aria-hidden="true" data-id="element-105" data-mp="ximac0w49uq3" />
          </span>
          <h2 id="guarantee-title" className="mt-6 text-3xl font-extrabold text-forest-950" data-id="element-106" data-mp="12k39nryyd94k">
            Garantía total de 7 días
          </h2>
          <p className="mt-4 leading-relaxed text-earth-800" data-id="element-107" data-mp="17fqu5u2hpe3q">
            Abre los 9 tomos. Revisa los 5 bonos. Úsalos en tu clase más difícil esta semana. Si sientes que tus alumnos
            no respondieron mejor, o que el material no te ahorró horas de trabajo:
          </p>
          <p className="mt-6 rounded-lg bg-forest-900 px-5 py-4 text-lg font-extrabold text-cream" data-id="element-108" data-mp="1vu0zw10cg93i">
            Te devolvemos el 100% de tu dinero. Sin preguntas. Sin formularios. Sin complicaciones.
          </p>
          <p className="mt-5 text-sm leading-relaxed text-earth-700" data-id="element-109" data-mp="2ok9a96on1p7j">
            Porque si el material no te da el valor que prometemos, no queremos quedarnos con tu dinero.
          </p>
        </motion.div>
      </div>
    </section>;
}